import { useEffect } from "react";
import PropTypes from "prop-types";

import Badge from "@mui/material/Badge";

import { useProjectLiveChat } from "./useProjectLiveChat";

export default function ProjectLiveChatBadge({ projectId, children }) {
  const { getProjectLiveChatUnreadCount, watchProjectLiveChat } = useProjectLiveChat();
  const unreadCount = getProjectLiveChatUnreadCount(projectId);

  useEffect(() => watchProjectLiveChat(projectId), [projectId, watchProjectLiveChat]);

  return (
    <Badge
      badgeContent={unreadCount}
      color="error"
      invisible={unreadCount <= 0}
      max={99}
      sx={{
        "& .MuiBadge-badge": {
          minWidth: 14,
          height: 14,
          padding: "0 3px",
          fontSize: "0.55rem",
        },
      }}
    >
      {children}
    </Badge>
  );
}

ProjectLiveChatBadge.propTypes = {
  projectId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  children: PropTypes.node.isRequired,
};
